<template>
    <v-date-picker
        ref="calendar"
        v-model="range"
        is-range
        locale="pt-BR"
        :popover="{ visibility: 'focus' }"
        :model-config="modelConfig"
        mode="dateTime" 
        >
        <template #default="{ togglePopover }">
            <div
                :class="[
                    { 'ui-calendar-range': icon }
                ]"
            >
                <!-- Here is the icon / label of the input, being optional -->
                <span
                    v-if="icon"
                    class="button-calendar"
                    :class="{
                        'button-error': setError,
                        'button-active': popoverOpen || isButtonActive
                    }"
                    @keydown.enter="apply"
                    @click="togglePopover"
                >
                    <i class="fal fa-calendar-alt" :class="{ 'icon-danger': setError }" />
                </span>

                <div v-if="setError" class="observation-message" :class="{ 'error': setError }">
                    {{ observation }}
                </div>
            </div>
        </template>

        <template #footer>
            <div class="calendar-range-footer">
                <ui-button
                    design="primary xs mw-60"
                    @click="onClick"
                >
                    Aplicar
                </ui-button>
            </div>
        </template>
    </v-date-picker>
</template>

<script>
    import vDatePicker from 'v-calendar/lib/components/date-picker.umd'
    import { uiButton } from '@/components/ui/buttons'

    export default {
        name: 'ui-calendar-range',

        components: {
            vDatePicker,
            uiButton
        },

        props: {
            /**
                * This property defines whether the input will have the icon
                * calendar added to the component's visual
                */
            icon: {
                type: Boolean,
                required: false,
                default: true
            },

            /**
                * mostra uma informação abaixo do select
                */
            observation: {
                type: String,
                default: ''
            },
            error: {
                type: Boolean,
                required: false,
                default: false
            },
            /**
             * função ao clicar no botao de adicionar
             */
            onClickApply: {
                type: Function,
				required: false,
				default: () => {},
            },
            /**
             * Verifica se o botao possa ter datas selecionadas e deixa ativo
             */
            isButtonActive: {
                typoe: Boolean,
                require: false,
                default: false
            }
        },

        data() {
            return {
                range: {
                    start: null,
                    end: null,
                },
                modelConfig: {
                    start: {
                        timeAdjust: '00:00:00'
                    },
                    end: {
                        timeAdjust: '23:59:59'
                    }
                },
                setError: this.error,
                popoverOpen: false
            }
        },

        watch: {
            error: {
                immediate: true, // Chama a função de callback imediatamente após o componente ser montado
                handler(newValue) {
                    this.setError = newValue
                }
            }
        },

        mounted() {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    const isPopoverOpen = mutation.target.children.length > 0 ? true : false
                    this.popoverOpen = isPopoverOpen
                })
            })

            const popover = this.$refs.calendar.$el.querySelector('.vc-popover-content-wrapper')
            if (popover) {
                observer.observe(popover, {
                    attributes: true
                })
            }
        },

        methods: {
            onClick() {
                this.onClickApply({
                    initialDate: this.range.start,
                    finalDate: this.range.end
                })
                // Fecha o popover do calendário
                this.$refs.calendar.togglePopover(false);
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>